<div class="hint mb-4">
  <span>
    The new password must contain at least 12 characters.
  </span>
</div>
<div class="row reset-password">
  <!-- Container Position div-->
  <div class="col-md-10">
    <form name="form" (ngSubmit)="f.form.valid && submit(f)" #f="ngForm" novalidate>
      <div style="max-width:800px">
        <div class="form-group" [ngClass]="{ 'has-error': f.dirty && !existingpassword.valid }">
          <div>
            <label for="existingpassword">Old Password</label>
          </div>
          <div >
            <div class="position-relative">
              <input type="password" class="form-control" name="existingpassword" id="existingpassword" [(ngModel)]="model.existingpassword" #existingpassword="ngModel"
                [disabled]="config.demoSite" [title]="config.demoSite ? 'This functionality is not available on Demo Web Site' :''"
                required [attr.aria-invalid]="!existingpassword.valid" />
                <span class="material-icons-outlined passwordEye">visibility</span>
              </div>
              @if (f.dirty && !existingpassword.valid) {
                <div class="validation-error">*Existing password is required</div>
              }
            </div>
          </div>
          <div class="form-group" [ngClass]="{ 'has-error': f.dirty && !password.valid }">
            <div>
              <label for="password">New Password</label>
            </div>
            <div>
              <div class="position-relative">
                <input type="password" class="form-control" name="password" id="password" [(ngModel)]="model.password" #password="ngModel"
                  validateEqual="confirmPassword"
                  reverse="true"
                  minlength="{{config.passwordRules.minLength}}"
                  maxlength="{{config.passwordRules.maxLength}}"
                  [disabled]="config.demoSite" [title]="config.demoSite ? 'This functionality is not available on Demo Web Site' :''"
                  required [attr.aria-invalid]="!password.valid" />
                  <span class="material-icons-outlined passwordEye">visibility</span>
                </div>
                @if (f.dirty && !password.valid) {
                  <div class="validation-error">
                    @if (password?.errors?.['required']) {
                      <span>*Password is required.</span>
                    }
                    @if (password?.errors?.['minlength']) {
                      <span>*Password must contain at least 12 characters.</span>
                    }
                  </div>
                }
              </div>
            </div>
            <div class="form-group" [ngClass]="{ 'has-error': f.dirty && !confirmPassword.valid }">
              <div>
                <label for="confirmPassword">Confirm New Password</label>
              </div>
              <div>
                <div class="position-relative">
                  <input type="password" class="form-control" name="confirmPassword" id="confirmPassword" [(ngModel)]="model.confirmPassword" #confirmPassword="ngModel"
                    validateEqual="password" reverse="false"
                    maxlength="{{config.passwordRules.maxLength}}"
                    [disabled]="config.demoSite" [title]="config.demoSite ? 'This functionality is not available on Demo Web Site' :''"
                    [attr.aria-invalid]="!confirmPassword.valid"
                    />
                    <span class="material-icons-outlined passwordEye">visibility</span>
                  </div>
                  @if (f.dirty && !confirmPassword.valid) {
                    <div class="validation-error">
                      @if (confirmPassword?.errors?.['validateEqual']) {
                        <span>*Passwords do not match.</span>
                      }
                    </div>
                  }
                </div>
              </div>
              <div class="row">
                <div class="col-6 offset-4">
                  <caps-lock />
                </div>
              </div>
            </div>
            <button class="btn btn-sm btn-primary px-5" [disabled]="config.demoSite || isImpersonated" [title]="config.demoSite ? 'This functionality is not available on Demo Web Site' :''" style="min-width: 110px;">Change Password</button>

            @if (hasError()) {
              <div class="alert alert-danger">{{errorMsg}}</div>
            }
            @if (hasMessage()) {
              <div class="alert alert-success">{{successMsg}}</div>
            }
          </form>
        </div>
      </div>
